import CloseIcon from '@mui/icons-material/Close';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import IconButton from '../../Inputs/IconButton';
import {useModalTitleId} from '../BaseModal/titleId';

interface ModalHeaderProps {
  id?: string;
  title: React.ReactNode;
  subtitle?: string | React.ReactNode;
  description?: string | React.ReactNode;
  close?: () => void;
}

const styles = {
  root: {
    mb: 2,
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    gap: 2,
    width: '100%',
  },
  title: {
    width: '100%',
    minWidth: 0,
    overflowWrap: 'anywhere',
  },
  closeButton: {
    m: 0,
    color: 'text.secondary',
  },
};

export default function ModalHeader({id, title, subtitle, description, close}: ModalHeaderProps) {
  const isTitleString = typeof title === 'string';
  const titleId = useModalTitleId();

  return (
    <Box sx={styles.root}>
      <Box sx={styles.title}>
        {isTitleString ? (
          <Typography
            id={titleId}
            component="h1"
            variant="h5"
            gutterBottom={!!subtitle || !!description}
          >
            {title}
          </Typography>
        ) : (
          <Box id={titleId}>{title}</Box>
        )}
        {subtitle ? (
          <Typography variant="overline" fontSize={10}>
            {subtitle}
          </Typography>
        ) : null}
        {description ? <Typography>{description}</Typography> : null}
      </Box>
      {close ? (
        <IconButton
          id={id ? `${id}-close-modal-icon` : 'close-modal-icon'}
          ariaLabel="Close modal"
          icon={<CloseIcon />}
          onClick={close}
          color="secondary"
          sx={styles.closeButton}
        />
      ) : null}
    </Box>
  );
}
